import Select from "react-select";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

interface Props {
  handleReset: () => void;
  segmentsOptions: any[];
  sectorsOptions: any[];
  sitesOptions: any[];
  sectorValue: number | null;
  setSectorValue: React.Dispatch<React.SetStateAction<number | null>>;
  sitevalue: number | null;
  setSiteValue: React.Dispatch<React.SetStateAction<number | null>>;
  segmentValue: number | null;
  setSegmentValue: React.Dispatch<React.SetStateAction<number | null>>;
  reportsCategoreisOptions: any[];
  reportsCategories: any[];
  setReportsCategories: React.Dispatch<React.SetStateAction<any[]>>;
  reportsOrVoiceReports: string;
  setReportsOrVoiceReports: React.Dispatch<React.SetStateAction<string>>;
  reports: any[];
  setReports: React.Dispatch<React.SetStateAction<any[]>>;
  voiceReports: any[];
  setVoiceReports: React.Dispatch<React.SetStateAction<any[]>>;
  reportId: number | null;
  setReportId: React.Dispatch<React.SetStateAction<number | null>>;
  report: any;
  setReport: React.Dispatch<React.SetStateAction<any>>;
  isLoading: string;
  reportsOptions: any[];
  setVersionId: React.Dispatch<React.SetStateAction<number | null>>;
  setVersionsCount: React.Dispatch<React.SetStateAction<number>>;
  setReportVersion: React.Dispatch<React.SetStateAction<number>>;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
}

export const ReportsAnswersSelects = ({
  handleReset,
  segmentsOptions,
  sectorsOptions,
  sitesOptions,
  sectorValue,
  setSectorValue,
  sitevalue,
  setSiteValue,
  segmentValue,
  setSegmentValue,
  reportsCategoreisOptions,
  reportsCategories,
  setReportsCategories,
  reportsOrVoiceReports,
  setReportsOrVoiceReports,
  reports,
  setReports,
  voiceReports,
  setVoiceReports,
  reportId,
  setReportId,
  setReport,
  isLoading,
  reportsOptions,
  setVersionId,
  setVersionsCount,
  setReportVersion,
  setSearchValue,
}: Props) => {
  const { t } = useTranslation();
  const [_, setSearchParams] = useSearchParams();

  return (
    <div className="flex itemce-center justify-between mt-4">
      <div className="flex max-xl:flex-col gap-4 w-fit">
        <Select
          className="min-w-[12rem]"
          options={segmentsOptions}
          value={segmentsOptions.find(
            (option: any) => option.value === segmentValue
          )}
          onChange={(selectedOption) => {
            setSiteValue(null);
            setReportsOrVoiceReports("");
            setReports([]);
            setReportsCategories([]);
            setVoiceReports([]);
            setReportId(null);
            setReport(null);
            setSectorValue(null);
            setSegmentValue(selectedOption?.value as number);
            setSearchParams(
              (prev) => {
                const newParams = new URLSearchParams(prev);
                newParams.set("segmentId", String(selectedOption?.value));
                prev.delete("sectorId");
                prev.delete("siteId");
                prev.delete("reportCategory");
                prev.delete("reportId");
                return newParams;
              },
              { replace: true }
            );
            setSearchValue("");
          }}
          placeholder={t("select_segment")}
          required
        />

        {segmentValue !== null && (
          <Select
            className="min-w-[10rem]"
            options={sectorsOptions}
            value={sectorsOptions.find(
              (option: any) => option.value === sectorValue
            )}
            onChange={(selectedOption) => {
              setSearchValue("");
              setSiteValue(null);
              setReportsOrVoiceReports("");
              setReports([]);
              setReportsCategories([]);
              setVoiceReports([]);
              setReportId(null);
              setReport(null);
              setSectorValue(selectedOption?.value as number);
              setSearchParams(
                (prev) => {
                  const newParams = new URLSearchParams(prev);
                  newParams.delete("siteId");
                  newParams.delete("reportCategory");
                  newParams.delete("reportId");
                  newParams.set("sectorId", String(selectedOption?.value));
                  return newParams;
                },
                { replace: true }
              );
            }}
            placeholder={t("select_sector")}
            key={segmentValue + "sector"}
            required
          />
        )}

        {sectorValue !== null && (
          <Select
            className="min-w-[13rem]"
            options={sitesOptions}
            value={sitesOptions.find(
              (option: any) => option.value === sitevalue
            )}
            onChange={(selectedOption) => {
              // setReportsOrVoiceReports("");
              // setReports([]);
              // setReportsCategories([]);
              // setVoiceReports([]);
              setSearchValue("");
              setReportId(null);
              setReport(null);
              setSiteValue(selectedOption?.value as number);
              setSearchParams(
                (prev) => {
                  const newParams = new URLSearchParams(prev);
                  newParams.set("siteId", String(selectedOption?.value));
                  newParams.delete("reportCategory");
                  newParams.delete("reportId");
                  return newParams;
                },
                { replace: true }
              );
            }}
            key={sectorValue + "site"}
            placeholder={t("select_site")}
            required
          />
        )}

        {sitevalue !== null && reportsCategories.length > 0 && (
          <Select
            className="min-w-[13rem]"
            options={reportsCategoreisOptions.filter((option) =>
              reportsCategories.includes(option.value)
            )}
            value={reportsCategoreisOptions.find(
              (option: any) => option.value === reportsOrVoiceReports
            )}
            onChange={(selectedOption) => {
              setSearchValue("");
              setReports([]);
              setVoiceReports([]);
              setReport(null);
              setReportId(null);
              setReportsOrVoiceReports(selectedOption?.value as string);
              setSearchParams(
                (prev) => {
                  const newParams = new URLSearchParams(prev);
                  newParams.set("reportCategory", selectedOption?.value || "");
                  return newParams;
                },
                { replace: true }
              );
            }}
            placeholder={t("select_report_category")}
            key={sitevalue + "reportCategory" + reportsOrVoiceReports}
            required
          />
        )}
        {isLoading === "" &&
          reportsCategories?.length === 0 &&
          reports?.length === 0 &&
          voiceReports?.length === 0 && (
            <div className="text-2xl font-bold">{t("no_reports")}</div>
          )}
        {(isLoading === "reportsCategories" || isLoading === "reports") && (
          <div className="spiner">
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
            <div className="bar4"></div>
            <div className="bar5"></div>
            <div className="bar6"></div>
            <div className="bar7"></div>
            <div className="bar8"></div>
            <div className="bar9"></div>
            <div className="bar10"></div>
            <div className="bar11"></div>
            <div className="bar12"></div>
          </div>
        )}
        {sitevalue !== null &&
          reports.length > 0 &&
          (reportsOrVoiceReports === "static" ||
            reportsOrVoiceReports === "dynamic") && (
            <Select
              className="w-52"
              options={reportsOptions}
              value={reportsOptions.find(
                (option: any) => option.value === reportId
              )}
              onChange={(selectedOption) => {
                // setFlowId(null);
                // setSearchValue("");
                // setFilterValues(defaultFilterValues);
                // setToggleOptions(defaultToggle);
                const selectedReport = reports.find(
                  (report) => report.report_id === selectedOption?.value
                );
                setVersionId(selectedReport.versionId);
                setVersionsCount(selectedReport.version);
                setReportVersion(selectedReport.version);
                setReportId(selectedOption?.value as number);
                handleReset();
                setSearchParams(
                  (prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.set("reportId", String(selectedOption?.value));
                    return newParams;
                  },
                  { replace: true }
                );
              }}
              key={reportsOrVoiceReports + sitevalue + "reportOption"}
              placeholder={t("select_report")}
              required
            />
          )}
        {sitevalue !== null &&
          reports.length === 0 &&
          isLoading === "" &&
          (reportsOrVoiceReports === "static" ||
            reportsOrVoiceReports === "dynamic") && (
            <div className="text-2xl font-bold">{t("no_reports")}</div>
          )}
      </div>
    </div>
  );
};
